import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    models         : [],
    model          : '',
    version        : '',
    color          : '',
    accessoriesList: [],
    optionsList    : [],
    accessories    : [],
    options        : [],
    mensualite     : '',
    visitedModels  : [],
    maintenance    : false,
    trade          : false,
    tradeCar       : {
      name: '',
      brand: '',
      model: '',
    },
    apport         : 50,
    utm            : {
      source  : '',
      campaign: '',
      medium  : '',
      content : ''
    }
  },
  mutations: {
    updateModels(state, models) { state.models = models },
    updateModel(state, model) {
      const versionIndex = model ? model.voitures.findIndex(({stock_epuise}) => !stock_epuise) : -1;
      state.model       = model ? model.id_simulateur_modele : ''
      state.version     = (model && model.voitures.length) ? model.voitures[versionIndex === -1 ? 0 : versionIndex].id_simulateur : ''
      state.color       = ''
      state.options     = []
      state.accessories = []
      state.mensualite  = ''
    },
    updateVisitedModels(state, model) { state.visitedModels.push(model) },
    updateVersion(state, {id_simulateur}) {
      state.version     = id_simulateur
      state.color       = ''
      state.options     = []
      state.accessories = []
      state.mensualite  = ''
    },
    // filterAccessoriesOptions(state, id) {
    //   state.accessoriesList = state.accessoriesList
    //     .filter(item => item.voiture === parseInt(id))
    //     .map(accessorie => {
    //       const index = state.accessories.findIndex(acc => acc.id === accessorie.id)
    //       return {...accessorie, selected: index !== -1 }
    //     })
    //   state.optionsList = state.optionsList
    //     .filter(item => item.voiture === parseInt(id))
    //     .map(option => {
    //       const index = state.options.findIndex(op => op.id === option.id)
    //       return {...option, selected: index !== -1 }
    //     })
    // },
    updateColor(state, color) { state.color = color },
    updateAccessoriesList(state, accessoriesList) { state.accessoriesList = accessoriesList },
    updateAccessories(state, accessories) { state.accessories = accessories },
    addAccessorie(state, accessorie) {
      state.accessories.push(accessorie)
    },
    removeAccessorie(state, id) {
      const index = state.accessories.findIndex(acc => acc.id === id)
      state.accessories.splice(index, 1)
    },
    updateOptionsList(state, optionsList) { state.optionsList = optionsList },
    updateOptions(state, options) { state.options = options },
    addOption(state, option) {
      state.options.push(option)
    },
    removeOption(state, id) {
      const index = state.options.findIndex(op => op.id === id)
      state.options.splice(index, 1)
    },
    updatesMonthlyPayment(state, mensualite) { state.mensualite = mensualite },
    updateApport(state, apport) { state.apport = apport },
    updateUTMs(state, utm) { state.utm = utm },
    updateMaintenance(state, maintenance) { state.maintenance = maintenance },
    updateTrade(state, trade) { state.trade = trade },
    updateTradeCar(state, tradeCar) { state.tradeCar = tradeCar },
  },
  actions: {
    setModels({commit}, payload) { commit('updateModels', payload) },
    setModel({commit}, payload) { commit('updateModel', payload) },
    setVisitedModels({commit}, payload) { commit('updateVisitedModels', payload) },
    setVersion({commit}, payload) { commit('updateVersion', payload) },
    setColor({commit}, payload) { commit('updateColor', payload) },
    setAccessoriesList({commit}, payload) { commit('updateAccessoriesList', payload) },
    setAccessories({commit}, payload) { commit('updateAccessories', payload) },
    addAccessorie({commit}, payload) { commit('addAccessorie', payload) },
    removeAccessorie({commit}, payload) { commit('removeAccessorie', payload) },
    setOptionsList({commit}, payload) { commit('updateOptionsList', payload) },
    setOptions({commit}, payload) { commit('updateOptions', payload) },
    addOption({commit}, payload) { commit('addOption', payload) },
    removeOption({commit}, payload) { commit('removeOption', payload) },
    setMonthlyPayment({commit}, payload) { commit('updatesMonthlyPayment', payload) },
    setApport({commit}, payload) { commit('updateApport', payload) },
    setUTMs({commit}, payload) { commit('updateUTMs', payload) },
    setMaintenance({commit}, payload) { commit('updateMaintenance', payload) },
    setTrade({commit}, payload) {
      commit('updateTrade', true)
      commit('updateApport', parseInt(payload.apport))
      commit('updateTradeCar', { brand: payload.marque, model: payload.model, name: payload.name })
    },
  },
  getters: {
    models: ({models}) => models,
    model: ({models, model}) => {
      const selectedModel = models.find(m => m.id_simulateur_modele === model)
      if (!selectedModel) return ''
      return selectedModel
    },
    versions: (state, {model}) => {
      if (!model) return ''
      return model.voitures.sort((a, b) => a.prix - b.prix)
    },
    version: ({version}, {model}) => {
      if (!model) return ''
      return model.voitures.find(v => v.id_simulateur === version)
    },
    colors: (_, {model, version}) => {
      return version ? model.couleurs.map(color => ({...color, prix: version.peinture})) : []
    },
    color: ({color}, {colors}) => { return colors.find(c => c.id === color) },
    accessories: ({accessories}) => accessories,
    options: ({options}) => options,
    accessoriesList: ({accessoriesList}, {version, accessories}) => {
      return !version ? [] : [...accessoriesList]
      .filter(item => item.voiture === parseInt(version.id))
      .map(accessorie => {
        const index = accessories.findIndex(acc => acc.id === accessorie.id)
        return {...accessorie, selected: index !== -1 }
      })
    },
    optionsList: ({optionsList}, {version, options}) => {
      return !version ? [] : [...optionsList]
        .filter(item => item.version === parseInt(version.id))
        .map(option => {
          const index = options.findIndex(op => op.id === option.id)
          return {...option, selected: index !== -1 }
        })
    },
    mensualite: ({mensualite}) => mensualite,
    utm: ({utm}) => utm,
    maintenance: ({maintenance}) => maintenance,
    trade: ({trade}) => trade,
    tradeCar: ({tradeCar}) => tradeCar,
    apport: ({apport}) => apport,
    visitedModels: ({visitedModels}) => visitedModels,
    total:(_, {version, color, accessories, options}) => {
      if (!version) return 0
      else {
        const versionPrice = version.prix
        const matricul     = parseInt(version.frais_immat)
        const service      = parseInt(version.frais_mise_en_service)
        const colorPrice   = color ? (color.code_couleur === 'blanc-glacier' ? 0 : color.prix) : 0
        let accessoriesPrice = accessories.map(accessorie => parseFloat(accessorie.prix))
        accessoriesPrice = accessoriesPrice.length ? accessoriesPrice.reduce((sum, price) => sum + price) : 0
        let optionsPrice = options.map(option => parseFloat(option.prix))
        optionsPrice = optionsPrice.length ? optionsPrice.reduce((sum, price) => sum + price) : 0
        return versionPrice + colorPrice + accessoriesPrice + optionsPrice + matricul + service
      }
    }
  },
  // plugins: [createPersistedState()]
})
